var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerBrown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 49,
    viewBox: "0 0 39 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2021 0.199219C29.6956 0.199219 38.2021 8.40462 38.2021 18.5265C38.2021 19.762 38.0754 20.9689 37.8338 22.1359C36.1568 34.3257 19.302 48.1992 19.302 48.1992C19.302 48.1992 4.95839 36.3927 1.41865 24.9931C0.632369 22.9822 0.202148 20.8028 0.202148 18.5265C0.202148 8.40462 8.70874 0.199219 19.2021 0.199219Z",
    fill: "#BD904C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25397_110669",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 21,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5759 14.3782H26.8284C27.4276 14.3782 27.9179 13.8879 27.9179 13.2887C27.9179 12.6895 27.4276 12.1992 26.8284 12.1992H11.5759C10.9767 12.1992 10.4864 12.6895 10.4864 13.2887C10.4864 13.8879 10.9767 14.3782 11.5759 14.3782ZM28.0922 16.3392C27.9942 15.838 27.5475 15.4676 27.0245 15.4676H11.3798C10.8568 15.4676 10.4101 15.838 10.3121 16.3392L9.22261 21.7865C9.09188 22.462 9.60393 23.0939 10.2903 23.0939H10.4864V28.5413C10.4864 29.1405 10.9767 29.6307 11.5759 29.6307H20.2916C20.8908 29.6307 21.3811 29.1405 21.3811 28.5413V23.0939H25.739V28.5413C25.739 29.1405 26.2292 29.6307 26.8284 29.6307C27.4276 29.6307 27.9179 29.1405 27.9179 28.5413V23.0939H28.114C28.8004 23.0939 29.3124 22.462 29.1817 21.7865L28.0922 16.3392ZM19.2021 27.4518H12.6653V23.0939H19.2021V27.4518Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25397_110669)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.20215,
    y: 9.19922,
    width: 24,
    height: 24,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBrown);
export default __webpack_public_path__ + "static/media/MarkerBrown.c65e5457926e1341baf7a3a95516637f.svg";
export { ForwardRef as ReactComponent };